import { render, staticRenderFns } from "./FormatMoney.vue?vue&type=template&id=ea19b044&"
import script from "./FormatMoney.vue?vue&type=script&lang=ts&"
export * from "./FormatMoney.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports